module.exports = __webpack_public_path__ + "media/images/category_rails-4500c4df8bb442cbf51a94920254ce6c.png";